import SportOnboarding from "./components/SportOnboarding";
import { swimmingConfig } from "./ch/sportConfig";

const Swimming = () => {
  return <SportOnboarding sportConfig={swimmingConfig} navKey="swimming" />;
};

export default Swimming;
